/* שני · מגירת הקטגוריות בנייד (ניווט א').
   theme.js ממשיך לפתוח ולסגור (המחלקה menu_open על body). הקובץ הזה רק מאזין למחלקה ומוסיף:
   פוקוס כלוא, Esc, החזרת פוקוס לכפתור התפריט, ואקורדיון אחד פתוח בדפדפנים בלי <details name>. */
(function () {
  'use strict';

  var drawer = document.getElementById('navigation-mobile');
  if (!drawer || !drawer.querySelector('[data-shnav]')) return;

  var body = document.body;
  var wrap = drawer.querySelector('.halo-sidebar-wrapper');
  var head = drawer.querySelector('.shnav-head');
  var closeBtn = drawer.querySelector('.halo-sidebar-close');
  var OPEN = 'menu_open';
  var isOpen = body.classList.contains(OPEN);
  var lastTrigger = null;

  drawer.setAttribute('role', 'dialog');
  drawer.setAttribute('aria-modal', 'true');
  drawer.setAttribute('aria-labelledby', 'shnav-title');

  function toggles() {
    return Array.prototype.slice.call(document.querySelectorAll('.mobileMenu-toggle'));
  }

  function setExpanded(value) {
    toggles().forEach(function (t) {
      t.setAttribute('aria-controls', 'navigation-mobile');
      t.setAttribute('aria-expanded', value ? 'true' : 'false');
    });
  }

  function focusTo(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  /* רק מה שמוצג בפועל: תוכן של אקורדיון סגור לא מרונדר ולכן אין לו מלבנים */
  function focusables() {
    var list = drawer.querySelectorAll('a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(list, function (el) {
      return el.getClientRects().length > 0;
    });
  }

  function closeDrawer() {
    if (closeBtn) closeBtn.click();
    else body.classList.remove(OPEN);
  }

  function onOpen() {
    var active = document.activeElement;
    lastTrigger = (active && active !== body && !drawer.contains(active)) ? active : (toggles()[0] || null);
    setExpanded(true);
    var target = closeBtn || focusables()[0];
    window.requestAnimationFrame(function () {
      if (isOpen) focusTo(target);
    });
    window.setTimeout(function () {
      if (isOpen && !drawer.contains(document.activeElement)) focusTo(target);
    }, 120);
  }

  function onClose() {
    setExpanded(false);
    var active = document.activeElement;
    if (!active || active === body || drawer.contains(active)) {
      var back = (lastTrigger && document.contains(lastTrigger)) ? lastTrigger : toggles()[0];
      focusTo(back);
    }
    lastTrigger = null;
  }

  new MutationObserver(function () {
    var now = body.classList.contains(OPEN);
    if (now === isOpen) return;
    isOpen = now;
    if (now) onOpen(); else onClose();
  }).observe(body, { attributes: true, attributeFilter: ['class'] });

  setExpanded(isOpen);

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      closeDrawer();
      return;
    }

    if (e.key !== 'Tab') return;

    var list = focusables();
    if (!list.length) { e.preventDefault(); return; }
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;

    if (!drawer.contains(active)) {
      e.preventDefault();
      focusTo(e.shiftKey ? last : first);
    } else if (e.shiftKey && active === first) {
      e.preventDefault();
      focusTo(last);
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      focusTo(first);
    }
  });

  /* אקורדיון: אחת פתוחה. toggle לא מבעבע, ולכן capture */
  drawer.addEventListener('toggle', function (e) {
    var opened = e.target;
    if (!opened || !opened.classList || !opened.classList.contains('shnav-acc') || !opened.open) return;

    Array.prototype.forEach.call(drawer.querySelectorAll('details.shnav-acc[open]'), function (other) {
      if (other !== opened) other.open = false;
    });

    var summary = opened.querySelector('summary');
    if (!summary || !wrap) return;
    var limit = wrap.getBoundingClientRect().top + (head ? head.offsetHeight : 0);
    var top = summary.getBoundingClientRect().top;
    if (top < limit) wrap.scrollTop -= (limit - top);
  }, true);

  /* חזרה אחורה מדף שנשמר בזיכרון הדפדפן: לא להישאר עם מגירה פתוחה */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && body.classList.contains(OPEN)) closeDrawer();
  });
})();
